import { render, staticRenderFns } from "./Logger.vue?vue&type=template&id=3488a46f"
import script from "./Logger.vue?vue&type=script&lang=js"
export * from "./Logger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports